import { clsx } from 'clsx'
import { getSvg, IconName } from 'icon/types'
import { CSSProperties, MouseEvent } from 'react'
import { omit } from 'util/object'
import css from './Icon.module.scss'

type Props = {
  name: IconName
  size?: number
  title?: string
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  error?: boolean
  success?: boolean
  className?: string
  style?: CSSProperties
  onClick?(event: MouseEvent): void
  onMouseDown?(event: MouseEvent): void
}

/**
 * Preview with search - https://fonts.google.com/icons
 */
export function Icon(props: Props) {
  const {
    name,
    size,
    title,
    primary,
    secondary,
    tertiary,
    success,
    error,
    onClick,
    onMouseDown,
  } = props

  const color = clsx(
    error && css.error,
    primary && css.primary,
    secondary && css.secondary,
    success && css.success,
    tertiary && css.tertiary,
  )

  const className = clsx(props.className, css.icon, color)
  const style = omit<CSSProperties>({ ...props.style })

  const Svg = getSvg(name)
  if (!Svg) return null

  return (
    <Svg
      className={className}
      style={style}
      width={size}
      height={size}
      title={title}
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      {name}
    </Svg>
  )
}
